import { dictToMap, mapEntries } from '@/helpers/DictHelpers';
export function groupBy(property, items) {
    const result = {};
    for (const item of items) {
        const key = item[property];
        result[key] ??= [];
        result[key].push(item);
    }
    return result;
}
export function groupByKey(items, keyFn) {
    const result = {};
    for (const item of items) {
        const key = keyFn(item);
        result[key] ??= [];
        result[key].push(item);
    }
    return result;
}
export function indexBy(property, items) {
    return mapEntries(groupBy(property, items), (items) => {
        if (items.length !== 1) {
            const key = String(property);
            throw new Error(`indexBy(${key}) encountered duplicate keys`);
        }
        return items[0];
    });
}
// TODO Rename to indexById().
export function indexItemsById(items) {
    return indexBy('id', items);
}
export function groupAsMap(items, property, keys) {
    return dictToMap(groupBy(property, items), keys);
}
/**
 * Returns the unique values of the specified property of each item in items.
 */
export function uniquePropertyValues(name, items) {
    return Array.from(new Set(items.map((item) => item[name])));
}
export function itemIDs(items) {
    return items.map((item) => item.id);
}
